import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { AppConfig } from 'src/app/core/_config/app.config';
import { Observable } from 'rxjs';
import { DownloadedFile } from '../../file-remitance/models/downloadFile';
import { FileService } from 'src/app/services/file.service';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class FileManageService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig, private fileService: FileService) {}

    getReceivingBatchs(params: any): Observable<any> {
        return this.http.get(`${this.API_URL}Receiving/Batch/ToManage`, params);
    }

    deleteReceivingBatchs(id: string): Observable<any> {
        return this.http.delete(`${this.API_URL}Receiving/Batch/${id}/DeleteBatch`);
    }

    countBacth(params: any) {
        return this.http.get<ResponseCustom>(`${this.API_URL}Receiving/Batch/Count`, params);
    }

    DownloadFile(legalEntityId: string, fileName: string): Observable<DownloadedFile> {
        return this.http
            .get(`${this.API_URL}Receiving/Batch/DownloadFile/${legalEntityId}/${fileName}`, {
                responseType: 'arraybuffer',
                observe: 'response',
            })
            .pipe(
                map((httpResponse: HttpResponse<ArrayBuffer>) =>
                    this.fileService.extractFileNameAndBlobService(httpResponse),
                ),
            );
    }
}
